import {
  FusionMelcoModelsDesign,
  useAPIAction,
  DesignsDraftApi,
} from "melco-shared-logic";
import { useFormikContext } from "formik";
import { QueryObserverResult } from "react-query";
import { designToInitialValues } from "../../../components/libraries/designs/DesignDetailForm";

export const useRevertDesign = (
  designId: string,
  refetch: () => Promise<QueryObserverResult<FusionMelcoModelsDesign, unknown>>
) => {
  const { resetForm } = useFormikContext();

  return useAPIAction(
    DesignsDraftApi,
    async (api) => {
      const data = await api.userDesignsRevert({
        id: designId,
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "libraries.designs.detail.revert",
      onSuccess: async () => {
        const refetchResult = await refetch();

        resetForm({
          values: refetchResult.data
            ? designToInitialValues(refetchResult.data)
            : {},
        });
      },
    }
  );
};
